export const LOADER_CONFIG = {
  textRotationEnabled: true,
  textRotationDelay: 6000
}
